import { Connection, clusterApiUrl } from '@solana/web3.js';

export const SOLANA_RPC_ENDPOINT =
  process.env.REACT_APP_SOLANA_RPC_URL || clusterApiUrl('devnet');

export function createSolanaConnection() {
  return new Connection(SOLANA_RPC_ENDPOINT, 'confirmed');
}

export function getPhantomProvider() {
  if (typeof window === 'undefined') {
    return null;
  }

  const provider = window.phantom?.solana || window.solana;

  if (provider?.isPhantom) {
    return provider;
  }

  return null;
}